import { useEffect, useState, useCallback } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import "../styles/components/progress.scss";
import "react-step-progress-bar/styles.css";

const Progress = ({ currentPage, steps, gotoPage }) => {
  const [percent, setPercent] = useState(0);

  const calculatePercent = useCallback(() => {
    let percent = 0;
    let currentStep = -1;
    let currentStepOrder = 0;
    let nextStepOrder = 0;

    for (const step of steps) {
      if (step.order <= currentPage) {
        currentStepOrder = step.order;
        currentStep++;
      }

      if (step.order > currentPage) {
        nextStepOrder = step.order;
        break;
      }
    }

    percent = Math.ceil((currentStep * 100) / (steps.length - 1));

    if (currentPage > currentStepOrder && currentPage < nextStepOrder) {
      const percentMin = Math.ceil((currentStep * 100) / (steps.length - 1));
      const percentMax = Math.ceil(((currentStep + 1) * 100) / (steps.length - 1));
      const percentStep = (percentMax - percentMin) / (nextStepOrder - currentStepOrder);
      const percentOffset = percentStep * (currentPage - currentStepOrder);
      percent = Math.ceil(percent + percentOffset);
    }
    setPercent(percent);
  }, [currentPage, steps]);

  useEffect(() => {
    if (currentPage === 0) {
      setPercent(0);
    } else {
      calculatePercent();
    }
  }, [currentPage, calculatePercent]);

  const handleStepClick = (step) => {
    if (window.location.host.includes("danone.local") || window.location.host === "localhost:3000") gotoPage(step.order);
    return;
  };

  return (
    <>
      {currentPage > 0 && (
        <div className="progress">
          <div className="progress-label">{percent}% </div>
          <div className="progress-bar">
            <ProgressBar percent={percent} filledBackground="#fff" unfilledBackground="#008830">
              {steps.map((step) => (
                <Step transition="" key={step.id}>
                  {({ accomplished }) => (
                    <div
                      className="step-bullet"
                      style={{ backgroundColor: `${accomplished ? "#fff" : "#008830"}` }}
                      onClick={() => handleStepClick(step)}></div>
                  )}
                </Step>
              ))}
            </ProgressBar>
          </div>
        </div>
      )}
    </>
  );
};

export default Progress;
